export default "__VITE_ASSET__C6c2N79w__"